var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('label',[_vm._v("Chest:")]),_c('input',{class:_vm.$style.input,attrs:{"type":"text","disabled":""},domProps:{"value":_vm.canvasOutput.output1}})])])}
var staticRenderFns = []

export { render, staticRenderFns }